import { Faker, base, en } from "@faker-js/faker";
import config from "@sg-protect/runtime-config";
import { createOpenApiHttp } from "openapi-msw";
import type { paths } from "../types.ts";

export function createFaker(seed: string) {
    const instance = new Faker({ locale: [base, en], seed: hashSeed(seed) });
    instance.setDefaultRefDate(new Date("2026-03-08"));

    return instance;
}

function hashSeed(name: string) {
    let hash = 0;
    for (const ch of name) {
        hash = ((hash << 5) - hash + ch.charCodeAt(0)) | 0;
    }

    return Math.abs(hash);
}

export const http = createOpenApiHttp<paths>({
    baseUrl: config.get().insights.api
});

export function paginate<T>(data: T[], page: number, pageSize: number) {
    return {
        data: data.slice((page - 1) * pageSize, page * pageSize),
        pagination: {
            page,
            pageSize,
            total: data.length
        }
    };
}
